// StatusCluster - section-specific status indicator cluster
// Renders three shapes: activity/editing status, visibility, favorite

import './StatusCluster.css';

export function StatusCluster({
  status = 'idle',    // 'idle' (hollow gray), 'active' (green), 'editing' (orange)
  isPublic = false,   // true => filled gray, false => hollow gray
  isFavorite = false, // true => filled gold, false => hollow gray
  className = ''
}) {
  const classes = ['status-cluster', className].filter(Boolean).join(' ');

  const statusShapeClass =
    status === 'editing'
      ? 'status-on-orange'
      : status === 'active'
        ? 'status-on-green'
        : 'status-off';

  return (
    <div className={classes} aria-label="Status indicators">
      <span
        className={[
          'status-shape',
          'status-shape-circle',
          statusShapeClass
        ].join(' ')}
        aria-label={
          status === 'editing'
            ? 'Editing'
            : status === 'active'
              ? 'Active'
              : 'Idle'
        }
      />
      <span
        className={[
          'status-shape',
          'status-shape-circle',
          isPublic ? 'status-on-gray' : 'status-off'
        ].join(' ')}
        aria-label={isPublic ? 'Public' : 'Private'}
      />
      <span
        className={[
          'status-shape',
          'status-shape-diamond',
          isFavorite ? 'status-on-gold' : 'status-off'
        ].join(' ')}
        aria-label={isFavorite ? 'Favorited' : 'Not favorited'}
      />
    </div>
  );
}

